/**
 * Moonpage 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

export const tagsConfig = {
  ...tagsCommonConfig,
  theme: {
    popupTagBgColor: '#EAF1FF',
    popupTagColor: brandTheme.textSecondary,
    filterBgColor: '#EAF1FF',
    filterActiveBgColor: brandTheme.primaryColor,
    filterColor: brandTheme.textSecondary,
    filterActiveColor: brandTheme.textInverse,
  },
} satisfies TagsPageConfig
